import { WEB_SOCKET_QCS_REDUCER_KEY } from './webSocketQCSReducer';

export const getStore = (state) => state[WEB_SOCKET_QCS_REDUCER_KEY];
export const getReadyState = (state) => getStore(state).readyState;
